import React, { useState } from "react";
import { string, node } from "prop-types";
import { generateNearlyUniqueID } from "common/uuid";
import "./instagram-reel.styles.scss";

const propTypes = {
  mediaSrc: string.isRequired,
  children: node
};

const InstagramReel = ({ mediaSrc, children = null }) => {
  const uuid = generateNearlyUniqueID();
  const [isLoaded, setIsLoaded] = useState(children);

  return (
    <div className="instagram-reel" data-testid="instagram-reel">
      <div className="reel-media">
        {children || (
          <video
            disablePictureInPicture
            autoPlay
            muted
            loop
            playsInline
            controls={false}
            src={mediaSrc}
            data-testid="video"
            onLoadedData={() => {
              setIsLoaded(true);
            }}
          />
        )}
        <div
          id={`placeholder-${uuid}`}
          className="instagram-reel--loading"
          style={{ display: isLoaded ? "none" : "block" }}
        />
        <div className="reel-body">
          <small className="reel-sponsored">
            <i className="fa fa-fw fa-bullhorn" aria-label="Sponsored" /> Sponsored
          </small>
        </div>
        <div className="reel-actions">
          <i className="fa fa-heart-o reel-action-icon" aria-label="Like" />
          <i className="fa fa-comment-o reel-action-icon" aria-label="Comment" />
          <i className="fa fa-paper-plane-o reel-action-icon" aria-label="Share" />
          <i className="fa fa-ellipsis-h reel-action-icon" aria-label="Share" />
        </div>
      </div>
    </div>
  );
};

InstagramReel.propTypes = propTypes;

export default InstagramReel;
